/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_appsync_graphqlEndpoint": "https://42gqgmcdnzctno43vrovva5kui.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-pf6mcm7ao5g55a7ixxm7mv3lsq",
    "aws_cloud_logic_custom": [
        {
            "name": "restApi8Seats",
            "endpoint": "https://msdoyp0kug.execute-api.ap-southeast-2.amazonaws.com/stage",
            "region": "ap-southeast-2"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-southeast-2:c61f6958-4373-421b-9fe5-17fa132ba322",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_tCYkAqsAq",
    "aws_user_pools_web_client_id": "3q4np2g2e5a6eq1qtf1pkkh5fk",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_dynamodb_all_tables_region": "ap-southeast-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "migration-stage",
            "region": "ap-southeast-2"
        }
    ],
    "aws_user_files_s3_bucket": "8seats-storage-81614a8683415-stage",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
